import * as PIXI from "pixi.js";
import { logoPath, assetList } from "../types/Config";


export default class TextureManager {
  private static logoPath: string = logoPath;
  private static assetList: string[] = assetList;
  private static textures: Record<string, PIXI.Texture>;
  static logo: Record<string, PIXI.Texture>;
  constructor() {
  }
  static async loadLogo(): Promise<void> {
    this.logo = await PIXI.Assets.load(this.logoPath);
  }
  static async load(cb: (v: number) => void): Promise<void> {
    this.textures = await PIXI.Assets.load(this.assetList, (p) => cb(Math.floor(p * 100)));

  }
  static getLogo() {
    return new PIXI.Texture(this.logo);
  }
  static getTexture(name: string): PIXI.Texture {
    const Texture = this.textures[name];
    if (!Texture) {
      console.log("texture is not found", name);
      return new PIXI.Texture(PIXI.Texture.EMPTY)
    }
    return new PIXI.Texture(Texture);
  }
}